export const strings = {
  checkOutThisArticle: 'Check%20out%20this%20article',
  company: 'Analytic Partners勘讯咨询',
  contact: '联系我们',
  industries: '行业洞察',
  learnMore: '了解更多',
  learnDetails: '了解详情',
  loading: '加载中…',
  next: '下一个',
  noPostsWereFound: '无法找到内容',
  pages: '页面',
  pastEvents: '往期活动',
  previous: '上一页',
  readMore: '查看更多',
  readDetails: '阅读详情',
  readThe: '阅读详情',
  register: '注册',
  related: '相关内容',
  search: '搜索',
  solutions: '解决方案',
  stickyCardTitle: '与我们同行',
  stickyCardExcerpt: '挖掘数据潜力，用数据赋能营销。',
  stickyCardLinkText: '洽谈合作',
  tel: '电话: ',
  viewOpenPositions: '查看在招岗位',
}
